import React from "react";
import { Link } from "gatsby";

function LegUpSection() {
  return (
    <section
      id="pshelps"
      className="Index-page"
      data-collection-id="62dea26019970a3db2e86328"
      data-edit-main-image="Background"
    >
      <div className="Index-page-content ">
        <div
          className="sqs-layout sqs-grid-12 columns-12"
          data-type="page"
          id="page-62dea26019970a3db2e86328"
        >
          <div className="row sqs-row">
            <div className="col sqs-col-12">
              <div
                className="sqs-block html-block sqs-block-html"
                data-block-type="2"
                id="block-f82b5155f557c81479cc"
              >
                <div className="sqs-block-content">
                  <h2
                    style={{
                      fontSize: "1.5rem",
                      textAlign: "left",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    ProblemScape has everything students need to master Algebra
                  </h2>
                </div>
              </div>
              <div
                className="sqs-block spacer-block sqs-block-spacer sized vsize-1"
                data-block-type="21"
                id="block-07c1580175574e63e7a4"
                style={{ height: "0.5rem" }} // Adjust the height as needed
              >
                <div className="sqs-block-content">&nbsp;</div>
              </div>
            </div>
          </div>
          <div className="row sqs-row">
            <div className="col sqs-col-3 span-3">
              <div
                className="sqs-block html-block sqs-block-html"
                data-block-type="2"
                id="block-3047450cf593bac9ec42"
              >
                <div className="sqs-block-content">
                  <h3>
                    Adventure to make math relevant and reduce math anxiety
                  </h3>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    In ProblemScape, the fun adventure narrative puts a
                    spotlight on applications to make algebra meaningful and
                    help overcome math anxiety.
                    <br />
                    <Link to="/research/69u51bbtnacr79o5ttd9duwyt7lcpy/">
                      Read more…
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className="col sqs-col-3 span-3">
              <div
                className="sqs-block html-block sqs-block-html"
                data-block-type="2"
                id="block-035f667fe9dcce8e590a"
              >
                <div className="sqs-block-content">
                  <h3>Multimodal research-backed content to learn concepts </h3>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    Videos and animations in ProblemScape are grounded in
                    mathematics education research and explain concepts while
                    addressing common errors and misconceptions. <br />
                    <Link to="/research/all-equals-are-not-equal/">
                      Read more…
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className="col sqs-col-3 span-3">
              <div
                className="sqs-block html-block sqs-block-html"
                data-block-type="2"
                id="block-154609400e45c00b28f9"
              >
                <div className="sqs-block-content">
                  <h3>Practice to develop self-efficacy and metacognition</h3>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    Instead of having students solve problem after problem to
                    progress through an adaptive sequence, practice in
                    ProblemScape gives students autonomy and control, both of
                    which are shown to increase motivation and self-efficacy.{" "}
                    <br />
                    <Link to="/research/practice-can-lead-to-proficiency-but-only-if/">
                      Read more…
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className="col sqs-col-3 span-3">
              <div
                className="sqs-block html-block sqs-block-html"
                data-block-type="2"
                id="block-9f45a02f7a77750d038a"
              >
                <div className="sqs-block-content">
                  <h3>
                    Scaffolded review to prepare for tests and assessments
                  </h3>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    In education, the scaffold metaphor is used to indicate the
                    support given to students for enabling learning and
                    retention. ProblemScape provides students with just the
                    right scaffold so that they reap the benefits of spaced
                    reviews and tests.
                    <br />
                    <Link to="/research/the-good-is-in-the-testing-not-the-results/">
                      Read more…
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LegUpSection;
